"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeFlow = changeFlow;
var _action_types = require("../../constants/action_types");
var _events = require("../../types/events");
function changeFlow(flow) {
  return (dispatch, _getState, context) => {
    dispatch({
      type: _action_types.FLOW_CHANGE_FLOW_TYPE,
      flow
    });
    context.emitter.emit(_events.EEventType.FlowChanged, {
      flow
    });
  };
}